import { toast } from "react-toastify";
import {
  FORM_SUBMIT_ERROR,
  FORM_SUBMIT_SUCCESS
} from "../../../constants/constants";

export const formSubmitError = (error, notificationMessage) => {
  return dispatch => {
    dispatch({
      type: FORM_SUBMIT_ERROR,
      error,
      notificationMessage
    });
    toast.info(`${notificationMessage}`, {
      position: toast.POSITION.BOTTOM_RIGHT
      
    });
    
  };
};

export const formSubmitSuccess = (error, notificationMessage) => {
  return dispatch => {
    dispatch({
      type: FORM_SUBMIT_SUCCESS,
      error,
      notificationMessage
    });
    toast.success(`${notificationMessage}`, {
      position: toast.POSITION.BOTTOM_RIGHT
    });
  };
};